/** 订单列表筛选：财务 5+1、物流 3 段（与 backend 口径一致；物流为全订单标配） */
import { isOrderPerformanceModuleEnabled } from '../../constants/orderPerformanceFeatureFlags';
import {
	ORDER_DELIVERY_STATUS_LABELS,
	ORDER_DELIVERY_STATUS_VALUES,
	ORDER_PAYMENT_STATUS_FILTER_VALUES,
	ORDER_PAYMENT_STATUS_LABELS,
} from './orderStatus.js';

export const ORDER_LIST_PAYMENT_STATUS_OPTIONS = ORDER_PAYMENT_STATUS_FILTER_VALUES.map((value) => ({
	value,
	label: ORDER_PAYMENT_STATUS_LABELS[value] ?? value,
}));

export const ORDER_LIST_DELIVERY_STATUS_OPTIONS = ORDER_DELIVERY_STATUS_VALUES.map((value) => ({
	value,
	label: ORDER_DELIVERY_STATUS_LABELS[value] ?? value,
}));

/** 状态分桶互斥子组成展示名（与 backend composition keys 一致） */
export const ORDER_LIST_STATUS_COMPOSITION_LABELS = {
	contractPending: '待签约',
	contractPendingWaitingPayDelivery: '签约·发货款',
	contractPendingWaitingPayAccept: '签约·验收款',
	contractPendingPayComplete: '签约·款齐',
	contractPendingWaitingPayCredit: '签约·额度还款',
	financeOverlapWaitingPayPlaceOrder: '预付未收',
	approvalApproved: '已审批',
	accountsReceivablePending: '有应收',
	zeroAccountsReceivable: '零应收',
	orderCompleted: '已完成',
	payCompleteOpen: '未完成',
	logisticsCompleteOpen: '未完成',
	financeOverlapWaitingPayDelivery: '重叠·发货款',
	financeOverlapWaitingPayAccept: '重叠·验收款',
	payComplete: '支付完成',
};

/** 各状态子组成展示顺序（与 backend ORDER_LIST_*_COMPOSITION_KEYS 一致） */
export const ORDER_LIST_PAYMENT_STATUS_COMPOSITION_ORDER = {
	waitingPayDelivery: ['accountsReceivablePending', 'zeroAccountsReceivable'],
	waitingPayAccept: ['accountsReceivablePending', 'zeroAccountsReceivable'],
	payComplete: ['orderCompleted', 'payCompleteOpen'],
};

export const ORDER_LIST_DELIVERY_STATUS_COMPOSITION_ORDER = {
	waitingDelivery: [
		'contractPendingWaitingPayDelivery',
		'contractPendingWaitingPayAccept',
		'contractPendingPayComplete',
		'contractPendingWaitingPayCredit',
		'financeOverlapWaitingPayPlaceOrder',
	],
	waitingAccept: ['financeOverlapWaitingPayDelivery', 'financeOverlapWaitingPayAccept', 'payComplete'],
	logisticsComplete: ['orderCompleted', 'logisticsCompleteOpen'],
};

export const getOrderListStatusCompositionOptions = (axis, statusValue) => {
	const orderMap = axis === 'paymentStatus' ? ORDER_LIST_PAYMENT_STATUS_COMPOSITION_ORDER : ORDER_LIST_DELIVERY_STATUS_COMPOSITION_ORDER;
	const keys = orderMap[statusValue];
	if (!keys?.length) return [];

	return keys.map((value) => ({
		value,
		label: ORDER_LIST_STATUS_COMPOSITION_LABELS[value] ?? value,
	}));
};

const paymentLabelMap = Object.fromEntries(ORDER_LIST_PAYMENT_STATUS_OPTIONS.map((o) => [o.value, o.label]));
const deliveryLabelMap = Object.fromEntries(ORDER_LIST_DELIVERY_STATUS_OPTIONS.map((o) => [o.value, o.label]));

const CANONICAL_PAYMENT_FILTER_VALUES = new Set(ORDER_LIST_PAYMENT_STATUS_OPTIONS.map((o) => o.value));
const CANONICAL_DELIVERY_FILTER_VALUES = new Set(ORDER_LIST_DELIVERY_STATUS_OPTIONS.map((o) => o.value));

/** 筛选面板：财务状态（绩效关闭时不展示「待确认最终成本」） */
export const getOrderListPaymentStatusFilterOptions = () => {
	if (isOrderPerformanceModuleEnabled()) {
		return ORDER_LIST_PAYMENT_STATUS_OPTIONS;
	}
	return ORDER_LIST_PAYMENT_STATUS_OPTIONS.filter((o) => o.value !== 'pendingFinalCostConfirmation');
};

/** 筛选面板：物流状态（固定 3 段；全角色/全租户，不受绩效模块开关影响） */
export const getOrderListDeliveryStatusFilterOptions = () => ORDER_LIST_DELIVERY_STATUS_OPTIONS;

export const getOrderListPaymentStatusLabel = (value) => paymentLabelMap[value] ?? value;

export const getOrderListDeliveryStatusLabel = (value) => deliveryLabelMap[value] ?? value;

/** @deprecated 筛选项已固定为 canonical 列表，保留签名兼容旧调用 */
export const buildOrderListPaymentStatusSelectOptions = () => getOrderListPaymentStatusFilterOptions();

/** @deprecated 筛选项已固定为 canonical 列表，保留签名兼容旧调用 */
export const buildOrderListDeliveryStatusSelectOptions = () => getOrderListDeliveryStatusFilterOptions();

/** 清除 localStorage 中非 canonical 的财务/物流筛选值 */
export const normalizeOrderListStatusFilterValues = (paymentStatus = [], deliveryStatus = []) => ({
	paymentStatus: [...new Set((paymentStatus ?? []).filter((v) => CANONICAL_PAYMENT_FILTER_VALUES.has(v)))],
	deliveryStatus: [...new Set((deliveryStatus ?? []).filter((v) => CANONICAL_DELIVERY_FILTER_VALUES.has(v)))],
});
